/**
 * A bot oldalának részei (bot.mortisengine.com) — a menüsáv, a Dashboard és a stáb lapja innen olvassa.
 * Ki mit lát: a Dashboard mindenkinek, aki beléphet (élő előfizetés, fagyasztás, örökös licenc); a Library review a
 * könyvtár-moderátoroknak (tester, admin, owner — constants/roles.js canModerateLibrary); a stáb lapja adminnak és
 * ownernek. A backend ugyanezt kéri (bot-backend: routes/*.routes.js).
 */

export const isStaffRole = (role) => role === 'admin' || role === 'owner';

/** A Dashboard fülei — mindegyiknek saját címe van, a fülsor ezekre navigál. */
export const DASHBOARD_TABS = [
  { id: 'licence', path: '/licence', label: 'Licence & launcher', hint: 'Your licence, the launcher download and HWID' },
  { id: 'routes',  path: '/routes',  label: 'Routes',           hint: 'Your cloud routes' },
  { id: 'library', path: '/library', label: 'Route library',    hint: 'Routes shared by players' },
  { id: 'review',  path: '/review',  label: 'Library review',   hint: 'Library submissions to check', moderators: true },
  { id: 'farming', path: '/farming', label: 'Farming',          hint: 'Your farm statistics' },
];

/** A stáb lapjának fülei (/staff?tab=…). */
export const STAFF_TABS = [
  // 2026-10-08: az app-belépések (lista, visszavonás, HWID-reset — CSAK itt) és külön fülön a meghívó-kódok.
  { id: 'accounts',    label: 'Accounts',         hint: 'App logins and HWID resets' },
  { id: 'invites',     label: 'Invite codes',     hint: 'The last /invite codes' },
  { id: 'moderation',  label: 'Route moderation', hint: "A player's routes and shares" },
  { id: 'leaderboard', label: 'Leaderboard',      hint: 'The farm leaderboard' },
  { id: 'changelog',   label: 'Changelog editor', hint: 'Write and publish the bot changelog' },
  // 2026-10-11: a stáb feladat-táblája — két külön fül (a tulajdonos: „a botnak és a launchernek kell két külön fül”).
  // A `product` a bot-backend staff_tasks.product értéke; a számláló a nyitott (nem kész) tételek száma.
  { id: 'bot-tasks',      label: 'Bot tasks',      hint: 'Plans, bugs and tests for the bot',          product: 'bot' },
  { id: 'launcher-tasks', label: 'Launcher tasks', hint: 'Plans, bugs and tests for the Mortis Launcher', product: 'launcher' },
  { id: 'settings',    label: 'Settings',         hint: 'Route library on / off', owner: true },
];
